import { inject, Injectable } from "@angular/core";
import { MaintenanceFfaControllerService } from "../generated";
import { MaintenanceDate } from "../../../model/maintenance-schedule.model";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class MaintenanceFfaService {
    private maintenanceFfaService = inject(MaintenanceFfaControllerService);

    setMaintenance(maintenanceDate: MaintenanceDate): Observable<void> {
        const requestBody = {
            start: maintenanceDate.maintenanceStartDate.toISOString(),
            end: maintenanceDate.maintenanceEndDate.toISOString(),
        }
        return this.maintenanceFfaService.setMaintenance({ requestBody });
    }

    stopMaintenance(): Observable<void> {
        return this.maintenanceFfaService.stopMaintenance();
    }
}